import { HttpClientPlugin } from '../types';

export function createWithIfMatchPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      const { withIfMatch = false } = options;
      if (!withIfMatch) {
        return { url, options };
      }

      options.headers = new Headers(options.headers);
      options.headers.append('If-Match', withIfMatch);

      return { url, options };
    },
  };
}
